import React from 'react'

export default function InventoryPage() {
  return (
    <div>InventoryPage</div>
  )
}
